// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"e1091cfc","246":"24c29eac","300":"82dced51","485":"dcb64bfe","495":"ca949fcf"}[chunkId] + ".chunk.js";
};